<div class="card border-0 shadow-sm">
  <div class="card-body p-4">
    <div class="d-flex align-items-center justify-content-between mb-4">

      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">
        <div class="d-flex align-items-center gap-3">
          <button type="button" class="btn btn-light btn-sm rounded-circle shadow-sm" (click)="goBack()"
            ngbTooltip="Back">
            <i class="mdi mdi-arrow-left"></i>
          </button>
          <div>
            <h5 class="fw-semibold mb-1">
              {{ customer?.name }}
            </h5>
            <span class="badge" [ngClass]="{
              'bg-success-subtle text-success border border-success': customer?.status === 'Active',
              'bg-warning-subtle text-warning border border-warning': customer.status === 'Trial',
              'bg-danger-subtle text-danger border border-danger': customer?.status === 'Inactive'
            }">
              {{ customer?.status }}
            </span>
          </div>

        </div>
        <div>
          <button type="button" class="btn btn-primary px-2  btn-sm" [disabled]="customer?.status === 'Inactive'"
            (click)="openEdit(customer, editModal)" ngbTooltip="Create new order">
            <i class="mdi mdi-plus me-1"></i>
            Create Order
          </button>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <div class="col-md-6">
        <div class="d-flex align-items-start gap-3">
          <i class="mdi mdi-email-outline fs-4 text-primary"></i>
          <div>
            <div class="text-muted small">Email</div>
            <div class="fw-medium">{{ customer.email }}</div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="d-flex align-items-start gap-3">
          <i class="mdi mdi-phone-outline fs-4 text-primary"></i>
          <div>
            <div class="text-muted small">Phone</div>
            <div class="fw-medium">{{ customer.phone }}</div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="d-flex align-items-start gap-3">
          <i class="mdi mdi-domain fs-4 text-primary"></i>
          <div>
            <div class="text-muted small">Company</div>
            <div class="fw-medium">{{ customer.company }}</div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="d-flex align-items-start gap-3">
          <i class="mdi mdi-star-outline fs-4 text-primary"></i>
          <div>
            <div class="text-muted small">Plan</div>
            <div class="fw-medium">{{ customer.plan }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row text-center g-3 mt-3">
      <div class="col-md-4">
        <div class="border rounded-3 p-3 h-100">
          <div class="text-muted small">Documents</div>
          <div class="fs-5 fw-semibold">{{ customer.documents }}</div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="border rounded-3 p-3 h-100">
          <div class="text-muted small">API Calls</div>
          <div class="fs-5 fw-semibold">{{ customer.apiCalls }}</div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="border rounded-3 p-3 h-100">
          <div class="text-muted small">MRR</div>
          <div class="fs-5 fw-semibold">
            ₹{{ customer.mrr }}
          </div>
        </div>
      </div>

    </div>

    <hr class="my-4">

    <div class="d-flex justify-content-between small text-muted">
      <div>
        Created · {{ customer.createdAt | date:'short' }}
      </div>
      <div>
        Updated · {{ customer.updatedAt | date:'short' }}
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3">
            <h4>Customer Orders</h4>
          </div>
          <!-- <div class="row g-3 mb-3 align-items-end">

            <div class="col-md-3 col-sm-6">
              <label class="form-label fw-semibold">
                <i class="mdi mdi-magnify me-1"></i> Search
              </label>
              <span class="p-input-icon-left w-100">
                <i class="pi pi-search"></i>
                <input pInputText type="text" class="w-100" placeholder="Search order..."
                  (input)="onSearch($event.target.value, dt, 'search')" />
              </span>
            </div>

            <div class="col-md-3 col-sm-6">
              <label class="form-label fw-semibold mb-1 fs-6">
                # Order ID
              </label>

              <span class="p-input-icon-left w-100">
                <i class="pi pi-hashtag"></i>
                <input pInputText type="text" class="w-100 fs-6" placeholder="Search Order ID..."
                  (input)="onSearch($event.target.value, dt, 'order')" />
              </span>
            </div>


            <div class="col-md-3 col-sm-6">
              <label class="form-label fw-semibold">
                <i class="mdi mdi-filter-variant me-1"></i> Status
              </label>
              <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" placeholder="All Status"
                appendTo="body" styleClass="w-100" (onChange)="onChange(dt)">
              </p-dropdown>
            </div>

            <div class="col-md-3 col-sm-6">
              <label class="form-label fw-semibold mb-1 fs-6">
                <i class="mdi mdi-calendar-range me-1"></i> Select Date Range
              </label>

              <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" dateFormat="dd/mm/yy"
                appendTo="body" styleClass="w-100 fs-6" (onSelect)="dt.reset()">
              </p-calendar>
            </div>
          </div> -->

          <p-table #dt [value]="orders" [lazy]="true" (onLazyLoad)="loadOrders($event)" [paginator]="true" [rows]="rows"
            [totalRecords]="totalRecords" [loading]="loading" [rowsPerPageOptions]="[10,20,50]"
            responsiveLayout="scroll" styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

            <ng-template pTemplate="header">
              <tr>
                <th>Order ID</th>
                <th>Plan</th>
                <th>Currency</th>
                <th>Notes</th>
                <th>Payment Mode</th>
                <th>Status</th>
                <th>Created</th>
                <!-- <th>Action</th> -->
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-order>
              <tr>
                <td>{{ order?._id }}</td>
                <td>{{ order.planName }}</td>
                <td>{{ order.currency }}</td>
                <td>{{ order.notes }}</td>
                <td>{{ order.paymentMethod }}</td>
                <td>
                  <div class="badge font-size-12" [ngClass]="{
                                            'bg-success-subtle text-success': order.status === 'Completed',
                                            'bg-warning-subtle text-warning': order.status === 'Pending',
                                            'bg-danger-subtle text-danger': order.status === 'Cancelled'
                                        }">{{ order.status }}</div>
                </td>
                <td>{{ order.createdAt | date:'short' }}</td>
                <!-- <td>
                  <button class="btn btn-sm btn-outline-primary" (click)="getOrderDetail(order)">
                    View
                  </button>
                </td> -->
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="9" class="text-center py-4 text-muted">
                  <i class="mdi mdi-database-off-outline me-2"></i>
                  No orders found
                </td>
              </tr>
            </ng-template>
          </p-table>


          <ng-template #editModal let-modal>
            <div class="modal-header">
              <h5 class="modal-title">Create New Plan</h5>
              <button class="btn-close" (click)="cancelEdit()"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 mb-3">
                  @for(plan of plans; track plan;){
                  <div class="list-group">
                    <button class="list-group-item list-group-item-action d-flex justify-content-between"
                      (click)="onChangePlan(plan)">
                      <span>{{ plan.name }}</span>
                      <strong>₹{{ plan.price }}</strong>
                    </button>
                  </div>
                  }
                  <div class="mt-3" *ngIf="selectedPlan.name">
                    <div class="alert alert-info">
                      <div class="row">
                        <div class="col-6">
                          <b>Selected Plan:</b> {{ selectedPlan.name }}<br />
                          <b>Price:</b> ₹{{ selectedPlan.price }}

                        </div>
                        <div class="col-6"> <b>Users Limit:</b> {{ selectedPlan.users }} <br>
                          <b>Documents Limit:</b> {{ selectedPlan.documents }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-4">
                  <label class="form-label fw-semibold">
                    Payment Mode <span class="text-danger">*</span>
                  </label>
                </div>
                <div class="col-8">
                  <div *ngFor="let payment of paymentType" class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="payment" [id]="payment" [value]="payment"
                      [(ngModel)]="selectedPaymentMode" [disabled]="payment === 'Online'" />

                    <label class="form-check-label" [for]="payment">
                      {{ payment }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label for="planNote" class="form-label fw-semibold">
                    Note
                  </label>
                  <input type="text" class="form-control" name="planNote" id="planNote" [(ngModel)]="planNote"
                    placeholder="Enter note" />
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-primary w-100" type="submit" (click)="CreatePlan()"
                [disabled]="!isEnable">Sumbit</button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>